import request from "@/utils/request"

export default function logout() {
    return request({
        url: '/user/signOut',
    })
}
